import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import i18n from "i18next";
import TopBar from "./TopBar";
import WorkflowTab from "./tabs/WorkflowTab";
import SuggestionsTab from "./tabs/SuggestionsTab";
import FlowViewerTab from "./tabs/FlowViewerTab";
import MutualExclusionOverlay from "./MutualExclusionOverlay";
import {
  closeInteractivityStudio,
  setInteractivityStudioTab,
  setInteractivityStudioBusy,
} from "../../../common/actions";
import "./InteractivityStudio.scss";

const TABS = [
  { id: "workflow", labelKey: "InteractivityStudio.tab.workflow", defaultLabel: "Workflow" },
  {
    id: "suggestions",
    labelKey: "InteractivityStudio.tab.suggestions",
    defaultLabel: "Suggestions",
  },
  {
    id: "flow-viewer",
    labelKey: "InteractivityStudio.tab.flow_viewer",
    defaultLabel: "Flow Viewer",
  },
];

function InteractivityStudio({
  open,
  tab,
  sceneTitle,
  sectionId,
  busy,
  onSetTab,
  onClose,
  onClearBusy,
}) {
  if (!open) return null;
  const tabs = TABS.map((t) => ({
    id: t.id,
    label: i18n.t(t.labelKey, { defaultValue: t.defaultLabel }),
  }));
  return (
    <Modal
      show={open}
      fullscreen
      onHide={onClose}
      backdrop="static"
      className="aidea-modal interactivity-studio"
    >
      <Modal.Header className="interactivity-studio__header">
        <TopBar
          tabs={tabs}
          activeTab={tab}
          sceneTitle={sceneTitle || "—"}
          sectionId={sectionId || ""}
          onTabChange={onSetTab}
          onClose={onClose}
        />
      </Modal.Header>
      <Modal.Body className="interactivity-studio__body">
        {tab === "workflow" && <WorkflowTab />}
        {tab === "suggestions" && <SuggestionsTab />}
        {tab === "flow-viewer" && <FlowViewerTab />}
        {busy && tab !== "suggestions" && (
          <MutualExclusionOverlay
            busy={busy}
            originatingTab="suggestions"
            onViewProgress={() => onSetTab("suggestions")}
            onCancel={() => {
              // Future: POST /jobs/:id/cancel. For now: just clear local busy.
              onClearBusy();
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  const present = (state.undoGroup && state.undoGroup.present) || {};
  const navItemsById = present.navItemsById || {};
  const viewToolbarsById = present.viewToolbarsById || {};
  const sceneId = present.navItemSelected;
  const scene = sceneId ? navItemsById[sceneId] : null;
  // Scene titles live in viewToolbarsById[sceneId].viewName (not on the nav item).
  const viewToolbar = sceneId ? viewToolbarsById[sceneId] : null;
  const sceneTitle =
    (viewToolbar && viewToolbar.viewName) || (scene && scene.title) || sceneId || null;
  return {
    open: state.interactivityStudio.open,
    tab: state.interactivityStudio.tab,
    busy: state.interactivityStudio.busy,
    sceneTitle,
    sectionId: scene ? scene.parent || "" : "",
  };
};
const mapDispatchToProps = (dispatch) => ({
  onSetTab: (tab) => dispatch(setInteractivityStudioTab(tab)),
  onClose: () => dispatch(closeInteractivityStudio()),
  onClearBusy: () => dispatch(setInteractivityStudioBusy(null)),
});
export default connect(mapStateToProps, mapDispatchToProps)(InteractivityStudio);
